import { combineEpics } from "redux-observable"
import { generateQohAdjustment, patchEpic } from "./epics"

export const productEpics = combineEpics(
    patchEpic,
    generateQohAdjustment
)


// WEBPACK FOOTER //
// ./src/state/product/epics/index.ts